import rootReducer from './redux-saga/reducers/rootReducer';
import rootSagas from './redux-saga/sagas/index';

export default function getRootModule() {
  return {
    id: 'DETAILPRICES',
    reducerMap: {
      DETAILPRICES: rootReducer,
    },
    sagas: [rootSagas],
  };
}
